import React, { useEffect, useState } from 'react';
import { KanaCard } from './KanaCard';
import './KanaPopover.css';

interface KanaInfo {
    kana: string;
    romaji: string;
    type: 'seion' | 'dakuon' | 'handakuon' | 'yoon';
    position: {
        group: number;
        period: number;
    };
    atomic: number;
    mass?: number;
}

interface KanaPopoverProps {
    kanaInfo: KanaInfo;
    triggerElement: HTMLElement;
    onClose: () => void;
    displayMode: 'both' | 'hiragana' | 'katakana';
    correspondingKana?: string;
}

export const KanaPopover: React.FC<KanaPopoverProps> = ({
    kanaInfo,
    onClose,
    displayMode,
    correspondingKana
}) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setIsVisible(true), 10);
        return () => clearTimeout(timer);
    }, [kanaInfo]);

    const handleClose = () => {
        setIsVisible(false);
        setTimeout(onClose, 300);
    };

    // Handle Escape key
    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                handleClose();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, []);

    return (
        <>
            <div
                className={`kana-sidebar-backdrop ${isVisible ? 'visible' : ''}`}
                onClick={handleClose}
            />
            <div className={`kana-sidebar-panel ${isVisible ? 'visible' : ''}`}>
                <KanaCard
                    kanaInfo={kanaInfo}
                    onClose={handleClose}
                    displayMode={displayMode}
                    correspondingKana={correspondingKana}
                />
            </div>
        </>
    );
};
